const messageCls = "_275mq1fc5j";

export { messageCls };
import "./styles.linaria.module.css";
//# sourceMappingURL=styles.js.map
